export default {
  brand: 'USFansLink',
  nav: {
    home: 'Home',
    spreadsheet: 'Spreadsheet',
    categories: 'Categories',
    guide: 'Guide',
    safety: 'Safety',
    shopGuide: 'Shopping Guide',
  },
  hero: {
    eyebrow: 'The USFans Resource Hub',
    title: 'USFans Spreadsheet — Find Creators, Links & Resources Faster',
    subtitle:
      'Explore a structured USFans spreadsheet resource with creator links, search guides, comparisons, updates and safety information — all in one place.',
    ctaPrimary: 'USFans Spreadsheet',
    ctaSecondary: 'Buy It Now',
    searchPlaceholder: 'Search USFans creators, links, reviews or resources...',
    trust: 'Organized Resources • Updated Guides • Safety-Focused Information',
  },
  category: {
    title: 'Browse by Category',
    subtitle:
      'Shop the latest USFans collections — shoes, apparel, accessories and more from our main store.',
    dropdownLabel: 'Choose a category',
    dropdownPlaceholder: 'Select a category to visit...',
    viewCategory: 'View category',
  },
  categories: {
    shoes: 'Shoes',
    hoodies: 'Hoodies / Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants / Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear / Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
  },
  valueProp: {
    title: 'Everything You Need to Navigate USFans Resources',
    cards: [
      { title: 'USFans Spreadsheet', text: 'Find organized creator and link resources.' },
      { title: 'Creator Search', text: 'Discover practical search and research methods.' },
      { title: 'Reviews & Guides', text: 'Explore reviews, costs, coupons, legitimacy and tutorials.' },
      { title: 'Safety Center', text: 'Learn how to identify suspicious links and protect your information.' },
    ],
  },
  core: {
    title: 'What Is the USFans Spreadsheet?',
    copy: 'The USFans Spreadsheet is a structured resource designed to make USFans creator discovery and link research easier. Explore organized information, guides and useful resources from one central hub.',
    tableHeaders: ['Creator', 'Category', 'Link', 'Status', 'Updated'],
    tableRows: [
      ['Creator One', 'Shoes', 'View', 'Active', 'This week'],
      ['Creator Two', 'Hoodies', 'View', 'Active', 'This week'],
      ['Creator Three', 'T-Shirts', 'View', 'Active', 'Last month'],
      ['Creator Four', 'Jersey', 'View', 'Active', 'Last month'],
      ['Creator Five', 'Accessories', 'View', 'Active', 'This month'],
    ],
    cta: 'Open USFans Spreadsheet',
  },
  intent: {
    title: 'Popular Search Topics',
    subtitle: 'Quick answers to the questions people ask most about USFans.',
    cards: [
      'USFans Review',
      'USFans Shipping Cost',
      'USFans Coupon',
      'USFans Discount Code',
      'USFans Warehouse',
      'Is USFans Legit?',
    ],
  },
  comparison: {
    title: 'Compare Your Options',
    subtitle: 'Choose the approach that fits how you like to browse and research.',
    headers: ['Resource', 'Best For', 'Organization', 'Searchability'],
    rows: [
      ['USFans Spreadsheet', 'Structured research', 'High', 'High'],
      ['Directory', 'Browsing', 'Medium', 'High'],
      ['Manual Search', 'Quick research', 'Low', 'Medium'],
    ],
  },
  safety: {
    title: 'Browse USFans Resources More Safely',
    copy: 'Verify domains, avoid suspicious redirects, never share passwords or payment details, avoid unknown downloads, beware of phishing and respect creator privacy.',
    cta: 'Visit Safety Center',
  },
  featuredGuide: {
    eyebrow: 'Featured Guide',
    title: 'USFans Spreadsheet: The Complete Guide',
    excerpt:
      'Learn what the USFans Spreadsheet is, how to use it to find creators and links, and how to stay safe while browsing.',
    readMore: 'Read the Guide',
  },
  pillar: {
    eyebrow: 'USFans Resource Library',
    title: 'USFans Pillar Guides',
    subtitle: 'In-depth resources covering creator search, links, safety, reviews and more.',
    readMore: 'Read the guide',
    backHome: 'Back to Home',
  },
  finalCta: {
    title: 'Ready to Explore USFans Spreadsheet Resources?',
    copy: 'Start with the USFans Spreadsheet and discover useful guides, comparisons and resources from one organized hub.',
    ctaPrimary: 'Explore USFans Spreadsheet',
    ctaSecondary: 'Visit Main Website',
  },
  footer: {
    tagline: 'USFansLink is an independent informational resource. Links, information and third-party services may change over time.',
    disclaimer: 'Users should independently verify important information and follow appropriate online safety practices.',
    navTitle: 'Explore',
    navLinks: ['Home', 'Spreadsheet', 'Creators', 'Guides', 'Safety'],
    legalTitle: 'Legal',
    legalLinks: ['About', 'Privacy', 'Terms', 'Disclaimer', 'Contact'],
    categoriesTitle: 'Categories',
    copyright: 'All rights reserved.',
  },
};